import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { UserMenuPopoverPage } from './user-menu-popover.page';

const routes: Routes = [
  {
    path: '',
    component: UserMenuPopoverPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserMenuPopoverPageRoutingModule {}
